let scrollMagicPromise;

export const loadScrollMagic = () => {
    if (!scrollMagicPromise) {
        scrollMagicPromise = import(
            /* webpackChunkName: "theme-scrollmagic" */ '../libs/scrollmagic.min.js'
        ).then(({ default: ScrollMagic }) => ScrollMagic);
    }

    return scrollMagicPromise;
};
